<!-- Copyright 2023, Common Good Learning Tools LLC -->
<template>
	<k-dialog v-model="dialog_open" fullscreen persistent scrollable>
		<k-card>
			<k-card-title style="border-bottom:1px solid #999">
				<div><b>Custom Script Runner:</b> {{custom_script_name}}</div>
				<k-spacer/>
				<k-btn color="primary" :disabled="!cs" class="mr-3" @click="run('run')">   Run <k-icon small class="ml-1 mr-3">fas fa-circle-arrow-right</k-icon></k-btn>
				<k-btn v-if="show_save_btn" color="primary" :disabled="!cs" class="mr-3" @click="run('save')">   SAVE <k-icon small class="ml-1 mr-3">fas fa-circle-arrow-right</k-icon></k-btn>
				<k-btn color="secondary" @click="$emit('dialog_cancel')">Done <k-icon small class="ml-2">fas fa-circle-xmark</k-icon></k-btn>
			</k-card-title>
			<k-card-text class="mt-3" style="font-size:16px">
				<div class="d-flex">
					<div v-if="input_required" class="mr-2" style="flex:0 1 45%">
						<div class="mb-1"><b>Input:</b></div>
						<div><k-textarea class="k-custom-script-text-area" outlined hide-details label="" placeholder="Type response here" v-model="input"></k-textarea></div>
					</div>
					<div :style="`flex:0 1 ${input_required?'55':'100'}%`">
						<div class="mb-1"><b>Output:</b></div>
						<div><k-textarea class="k-custom-script-text-area" outlined hide-details label="" placeholder="Type response here" v-model="output"></k-textarea></div>
					</div>
				</div>
			</k-card-text>
		</k-card>
	</k-dialog>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import './custom_scripts/ga_ela_progressions.js'
import './custom_scripts/sparkl_test_harness_input.js'
import './custom_scripts/update_derivative_use_aliases.js'
import './custom_scripts/change_siis_to_aliases.js'
import './custom_scripts/convert_help_docs.js'
import './custom_scripts/ga_ela_supp_info.js'
import './custom_scripts/linkit_compare.js'
import './custom_scripts/normalize_crosswalk_direction.js'
import './custom_scripts/align_services_test_harness.js'
import './custom_scripts/convert_playlists_to_sparkl.js'
import './custom_scripts/cps_import_assessments.js'

export default {
// components: { CustomScriptRunner },
	props: {
		custom_script_name: { type: String, required: true },
		// nreq: { type: String, required: false, default() { return ''} },
	},
	data() { return {
		dialog_open: true,
		input_required: true,
		show_save_btn: false,
		output: '',
	}},
	computed: {
		...mapState([]),
		...mapGetters([]),
		cs() { return window.custom_scripts[this.custom_script_name] },
		input: {
			get() { return this.$store.state.lst.last_custom_script_input },
			set(val) { this.$store.commit('lst_set', ['last_custom_script_input', val]) }
		},
	},
	watch: {
	},
	created() {
		this.run_btn_text = this.initial_run_btn_text
	},
	mounted() {
		if (!this.cs) {
			this.$alert(`Error: custom script “${this.custom_script_name}” not found`)
		} else {
			this.input_required = this.cs.input_required

			// if we have a pre_fn, run it
			if (this.cs.pre_fn) {
				this.cs.pre_fn().then((output)=>this.output = output)
			}
		}
	},
	methods: {
		run(btn_clicked) {
			this.cs.fn(this.input, btn_clicked).then((output)=>{
				// allow for output to be an array with [output, show_save_btn]
				let show_save_btn = false
				if ($.isArray(output)) {
					[output, show_save_btn] = output
					this.show_save_btn = show_save_btn
				} else {
					this.show_save_btn = false
				}
				this.output = output
			})
		}
	}
}
</script>

<style lang="scss">
.k-custom-script-text-area {
	textarea {
		overflow:auto!important;
		font-family:monospace;
		font-size:12px;
		line-height:14px!important;
		height:calc(100vh - 120px);
	}
}
</style>